import { BottomTabNavigationOptions } from "@react-navigation/bottom-tabs";

const tabScreenOptions: BottomTabNavigationOptions = {};

export default tabScreenOptions;
